import React, { useState } from 'react';
import { useStateContext } from '../../contexts/ContextProvider';
import DocumentEditor from '../../components/DocumentEditor';

const CreateLetter = () => {
	const { currentMode } = useStateContext();
	const [template, setTemplate] = useState(null);

	const handleSaveTemplate = () => {
		// Add save template logic here
	};

	const handleImportTemplate = () => {
		// Add import template logic here
	};

	return (
		<div className="w-full h-full flex flex-col overflow-hidden">
			{/* Fixed header section with buttons */}
			<div className="flex-shrink-0 bg-white dark:bg-gray-800 px-6 py-3 border-b border-gray-200 flex justify-between items-center">
				<h1 className="text-2xl font-bold text-gray-900 dark:text-white">Create Letter</h1>
				<div className="flex space-x-4">
					<button
						onClick={handleSaveTemplate}
						className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
					>
						<svg className="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
						</svg>
						Save Template
					</button>
					<button
						onClick={handleImportTemplate}
						className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
					>
						<svg className="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0l-4 4m4-4v12" />
						</svg>
						Import Template
					</button>
				</div>
			</div>

			{/* Document Editor Container - Takes remaining height with proper containment */}
			<div className="flex-1 min-h-0 relative">
				<DocumentEditor
					height="100%"
					template={template}
					onSave={(document) => {
						console.log('Saving document:', document);
					}}
				/>
			</div>
		</div>
	);
};

export default CreateLetter;